module.exports = __webpack_public_path__ + "media/images/favicon/favicon-150-0434c6383fe0b3725340b63907a23677.png";